import React from "react"
import Lang from "@components/Lang/Lang";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import './index.less'

const ExportBtn = (props) => {
    return (
        props.authName?
        <AuthBtn className="com-export-AuthBtn" icon={"ri-logout-box-r-line"} tips = {Lang({id:"DaoChuShuJu",default:"导出数据"})} auth={props.authName} onClick={props.onClick} title={Lang({id:"DaoChuShuJu",default:"导出数据"})}></AuthBtn>:
        <button className="com-export-btn" onClick={props.onClick}>
            <span className="ri-logout-box-r-line font_16"></span>
            <span className="font_14">{Lang({id: props.txt || "DaoChuShuJu"})}</span>
        </button>
    )
}

export default ExportBtn
